/**
 * Standardized icon sizes for lucide-react SVG icons.
 *
 * Use these constants instead of magic numbers so that icon sizing
 * stays consistent across the UI.
 */

/** Extra-small icon size (8px) — connection dots, status indicators. */
export const ICON_XS: number = 8;

/** Small icon size (12px) — inline status dots, small indicators, expand chevrons. */
export const ICON_SM: number = 12;

/** Medium icon size (14px) — tool card icons, close buttons, copy buttons. */
export const ICON_MD: number = 14;

/** Large icon size (16px) — navigation icons, notification icons. */
export const ICON_LG: number = 16;
